import { mod, toRadian, isSamePoint } from './util';
// åéé¿åº¦
function vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
// u.v/|u||v|ï¼è®¡ç®å¤¹è§çä½å¼¦å¼
function vRatio(u, v) {
    // å½å­å¨ä¸ä¸ªåéçé¿åº¦ä¸º 0 æ¶ï¼å¤¹è§ä¹ä¸º 0ï¼å³å¤¹è§çä½å¼¦å¼ä¸º 1
    return vMag(u) * vMag(v) ? (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v)) : 1;
}
// åéè§åº¦
function vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
}
// A 0:rx 1:ry 2:x-axis-rotation 3:large-arc-flag 4:sweep-flag 5: x 6: y
export default function getArcParams(startPoint, params) {
    var rx = params[1];
    var ry = params[2];
    var xRotation = mod(toRadian(params[3]), Math.PI * 2);
    var arcFlag = params[4];
    var sweepFlag = params[5];
    // å¼§å½¢èµ·ç¹åæ 
    var x1 = startPoint[0];
    var y1 = startPoint[1];
    // å¼§å½¢ç»ç¹åæ 
    var x2 = params[6];
    var y2 = params[7];
    var xp = (Math.cos(xRotation) * (x1 - x2)) / 2.0 + (Math.sin(xRotation) * (y1 - y2)) / 2.0;
    var yp = (-1 * Math.sin(xRotation) * (x1 - x2)) / 2.0 + (Math.cos(xRotation) * (y1 - y2)) / 2.0;
    var lambda = (xp * xp) / (rx * rx) + (yp * yp) / (ry * ry);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    var diff = rx * rx * (yp * yp) + ry * ry * (xp * xp);
    var f = diff ? Math.sqrt((rx * rx * (ry * ry) - diff) / diff) : 1;
    if (arcFlag === sweepFlag) {
        f *= -1;
    }
    if (isNaN(f)) {
        f = 0;
    }
    // æè½¬åçèµ·ç¹åæ ï¼ä¸å½é¿åè½´åç­åè½´çé¿åº¦ä¸º 0 æ¶ï¼åæ æ (0, 0) å¤ç
    var cxp = ry ? (f * rx * yp) / ry : 0;
    var cyp = rx ? (f * -ry * xp) / rx : 0;
    // æ¤­ååå¿åæ 
    var cx = (x1 + x2) / 2.0 + Math.cos(xRotation) * cxp - Math.sin(xRotation) * cyp;
    var cy = (y1 + y2) / 2.0 + Math.sin(xRotation) * cxp + Math.cos(xRotation) * cyp;
    // èµ·å§ç¹çåä½åé
    var u = [(xp - cxp) / rx, (yp - cyp) / ry];
    // ç»æ­¢ç¹çåä½åé
    var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
    // è®¡ç®èµ·å§ç¹ååå¿çè¿çº¿ï¼ä¸ x è½´æ­£æ¹åçå¤¹è§
    var theta = vAngle([1, 0], u);
    // è®¡ç®åå¼§èµ·å§ç¹åç»æ­¢ç¹ä¸æ¤­ååå¿è¿çº¿çå¤¹è§
    var dTheta = vAngle(u, v);
    if (vRatio(u, v) <= -1) {
        dTheta = Math.PI;
    }
    if (vRatio(u, v) >= 1) {
        dTheta = 0;
    }
    if (sweepFlag === 0 && dTheta > 0) {
        dTheta = dTheta - 2 * Math.PI;
    }
    if (sweepFlag === 1 && dTheta < 0) {
        dTheta = dTheta + 2 * Math.PI;
    }
    return {
        cx: cx,
        cy: cy,
        // å¼§å½¢çèµ·ç¹åç»ç¹ç¸åæ¶ï¼é¿è½´åç­è½´çé¿åº¦æ 0 å¤ç
        rx: isSamePoint(startPoint, [x2, y2]) ? 0 : rx,
        ry: isSamePoint(startPoint, [x2, y2]) ? 0 : ry,
        startAngle: theta,
        endAngle: theta + dTheta,
        xRotation: xRotation,
        arcFlag: arcFlag,
        sweepFlag: sweepFlag,
    };
}
//# sourceMappingURL=arc-params.js.map